import React, { useEffect } from 'react'

function PasswordAlertBox({password, onValidate}){

    useEffect(() => {

        if(onValidate){
            if(password.length < 8){
                onValidate(false)
            }
            else if(!/[a-z]/.test(password)){
                onValidate(false)
            }
            else if(!/[A-Z]/.test(password)){
                onValidate(false)
            }
            else if(!/\d/.test(password)){
                onValidate(false)
            }
            else {
                onValidate(true)
            }
        }
    }, [password])


    return password.length > 0 ? <div className="alert alert-info">
        <ul>
            <li className={password.length >= 8 ? 'text-success': 'text-danger'}>
                Password must be at least 8 characters in length
            </li>
            <li className={/[a-z]/.test(password) ? 'text-success': 'text-danger'}>
                Password must contain a lower case letter
            </li>
            <li className={/[A-Z]/.test(password) ? 'text-success': 'text-danger'}>
                Password must contain an upper case letter
            </li>
            <li className={/\d/.test(password) ? 'text-success': 'text-danger'}>
                Password must contain a number
            </li>
        </ul>
    </div>: <div></div>
}

PasswordAlertBox.defaultProps = {
    onValidate: false,
    password: ""
}

export default PasswordAlertBox